import React, { useState, useEffect } from 'react';

import {
  Box,
  Flex,
  Button,
  Text,
  Select,
  Input,
  useColorModeValue,
} from '@chakra-ui/react';

import axios from '../../utils/axios';

const initialState = {
  serviceType: '',
  serviceCreds: {
    sendgridAPI: '',
    sesHost: '',
    sesPort: '',
    sesUser: '',
    sesPassword: '',
  },
};

const EmailCredentials = () => {
  const [settings, setSettings] = useState(initialState);

  const getAllData = async () => {
    try {
      const res = await axios.get('/api/user/credentials');
      setSettings(res.data);
    } catch (error) {
      console.log('Error while geeting credentials', error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const { serviceType, serviceCreds } = settings;
  const { sendgridAPI, sesHost, sesPort, sesUser, sesPassword } = serviceCreds;

  const textColor = useColorModeValue('black', 'blue.primary');
  const hoverColor = useColorModeValue('black', 'blue.primary');
  const borderColor = useColorModeValue('orange.primary', 'white.primary');
  const btnColor = useColorModeValue('orange.primary', 'white.primary');
  const btnHover = useColorModeValue('orange.secondary', 'white.secondary');

  const handleChange = (e) => {
    setSettings({
      ...settings,
      serviceCreds: { ...serviceCreds, [e.target.name]: e.target.value },
    });
  };

  const handleSubmit = async (e) => {
    await axios.put('/api/user/credentials', settings);
  };

  return (
    <Box>
      <Text fontSize="xl" fontWeight={'bold'} mb={3}>
        Email Credentials
      </Text>
      <Select
        placeholder="Select option"
        borderColor={borderColor}
        borderRadius="12px"
        mb="24px"
        onChange={(e) =>
          setSettings({
            ...settings,
            serviceType: e.target.value,
            serviceCreds: {},
          })
        }
      >
        <option selected={serviceType == 'AWS SES' && true} value="AWS SES">
          AWS SES
        </option>
        <option selected={serviceType == 'Send Grid' && true} value="Send Grid">
          Send Grid
        </option>
        <option
          selected={serviceType == 'Simple Email' && true}
          value="Simple Email"
        >
          Simple Email
        </option>
      </Select>
      {/* Sendgrid */}
      {serviceType == 'Send Grid' && (
        <Box>
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="text"
            placeholder="Enter Sendgrid API KEY"
            size="lg"
            borderColor={borderColor}
            name="sendgridAPI"
            defaultValue={sendgridAPI}
            id="sendgridAPI"
            onChange={handleChange}
          />
        </Box>
      )}
      {/* AWS SES */}
      {serviceType == 'AWS SES' && (
        <Box>
          <Flex>
            <Input
              borderRadius="15px"
              mb="24px"
              fontSize="sm"
              type="text"
              placeholder="Enter SES Host address."
              size="lg"
              borderColor={borderColor}
              name="sesHost"
              defaultValue={sesHost}
              id="sesHost"
              onChange={handleChange}
            />
            <Input
              borderRadius="15px"
              mb="24px"
              ml="10px"
              fontSize="sm"
              type="text"
              placeholder="Enter SES Port."
              size="lg"
              borderColor={borderColor}
              name="sesPort"
              defaultValue={sesPort}
              id="sesPort"
              onChange={handleChange}
            />
          </Flex>
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="text"
            placeholder="Enter username."
            size="lg"
            borderColor={borderColor}
            name="sesUser"
            defaultValue={sesUser}
            id="sesUser"
            onChange={handleChange}
          />
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="password"
            placeholder="Enter password."
            size="lg"
            borderColor={borderColor}
            name="sesPassword"
            defaultValue={sesPassword}
            id="sesPassword"
            onChange={handleChange}
          />
        </Box>
      )}

      {/* Simple Email */}
      {serviceType == 'Simple Email' && (
        <Box>
          <Flex>
            <Input
              borderRadius="15px"
              mb="24px"
              fontSize="sm"
              type="text"
              placeholder="Enter Host"
              size="lg"
              borderColor={borderColor}
              name="emailHost"
              //   value={emailHost}
              id="emailHost"
              onChange={handleChange}
            />
            <Input
              borderRadius="15px"
              mb="24px"
              ml="10px"
              fontSize="sm"
              type="text"
              placeholder="Enter Port."
              size="lg"
              borderColor={borderColor}
              name="emailPort"
              //   value={emailPort}
              id="emailPort"
              onChange={handleChange}
            />
          </Flex>
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="password"
            placeholder="Enter password."
            size="lg"
            borderColor={borderColor}
            name="emailPassword"
            //   value={emailPassword}
            id="emailPassword"
            onChange={handleChange}
          />
        </Box>
      )}
      <Button
        fontSize="15px"
        type="button"
        bg={btnColor}
        w="100%"
        h="45"
        mb="20px"
        color={textColor}
        borderRadius={'12px'}
        _hover={{
          bg: btnHover,
          color: hoverColor,
        }}
        _active={{
          bg: btnHover,
          color: hoverColor,
        }}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </Box>
  );
};

export default EmailCredentials;
